$(document).ready(function () {
  // Add minus icon for collapse element which is open by default
  $(".collapse.show").each(function () {
    $(this)
      .prev(".card-header")
      .find(".fa")
      .addClass("fa-minus")
      .removeClass("fa-plus");
  });

  // Toggle plus minus icon on show hide of collapse element
  $(".collapse")
    .on("show.bs.collapse", function () {
      $(this)
        .prev(".card-header")
        .find(".fa")
        .removeClass("fa-plus")
        .addClass("fa-minus");
    })
    .on("hide.bs.collapse", function () {
      $(this)
        .prev(".card-header")
        .find(".fa")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    });

  //   icon up down

  $(".card-header.sub").click(function () {
    if ($(this).find(".angle").hasClass("fa-angle-down")) {
      $(".angle").addClass("fa-angle-right");
      $(this)
        .find(".angle")
        .removeClass("fa-angle-down")
        .addClass("fa-angle-right");
    } else {
      $(this)
        .find(".angle")
        .addClass("fa-angle-down")
        .removeClass("fa-angle-right");
    }
  });

  //     smooth scroll
  $("#book_treatment,#book_treatment_mobi").on("click", function (event) {
    event.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $("#contact_section").offset().top,
      },
      "slow"
    );
  });

  //   video control
  $("#control_view").hover(function toggleControls() {
    if (this.hasAttribute("controls")) {
      this.removeAttribute("controls");
    } else {
      this.setAttribute("controls", "controls");
    }
  });

  $(".play_button").on("click", function () {
    $("video#control_view").get(0).play();
  });
  $("#control_view, .play_button").on("click", function () {
    $(".play_button").hide();
  });
  //   form area
  var windowSize = $(window).width();

  //     input location
  $(".country_name").on("click", function () {
    var country = $(this).text();

    $("#location_input").val(country);
  });

  $("select.countryselect").change(function () {
    var selectedCountry = $(this).children("option:selected").val();
    $("#location_input").val(selectedCountry);
  });

  //treatment form
  $(".country_name").on("click", function () {
    $(".country_name").removeClass("active");
    $(this).addClass("active");
  });

  //.treatment__book .text-uppercase
  $(".treatment__book .text-uppercase").on("click", function () {
    $("html, body").animate(
      {
        scrollTop: $("#contact_section").offset().top,
      },
      2000
    );
    //scroll down to #contact_section
  });

  $("#form_submit").on("click", function () {
    var location = $("#treatment_form_id").find('input[name="location"]').val();
    var first_name = $("#treatment_form_id").find('input[name="fName"]').val();
    var last_name = $("#treatment_form_id").find('input[name="lName"]').val();
    var email = $("#treatment_form_id").find('input[name="email"]').val();
    var phone_number = $("#treatment_form_id")
      .find('input[name="phone_number"]')
      .val();

    if (
      location === "" ||
      first_name === "" ||
      last_name === "" ||
      email === "" ||
      phone_number === ""
    ) {
      $("#form_validation_mess").text("Please fill in all fields");
      $(".form-buttom button").removeClass("disabled");
      $(".form-buttom button").prop("disabled", false);
      return false;
    } else {
      $("#form_validation_mess").text("");
    }

    // Email js

    var templateParams = {
      first_name: first_name,
      last_name: last_name,
      email: email,
      phone_number: phone_number,
      location: location
    };
    
    emailjs.send('service_sq27ack', 'template_smgqlwg', templateParams).then(
      (response) => {
        console.log('SUCCESS!', response.status, response.text);
        $('.form-buttom button').addClass('disabled');
        $('.form-buttom button').prop('disabled', true);
        $('.form-buttom').after('<p class="success">Thanks for the Booking. We will reach you soon.</p>');
      },
      (error) => {
        console.log('FAILED...', error);
        $('.form-buttom').after('<p class="success">Something went wrong</p>');
      },
    );

    // try{
    //   Email.send({
    //     Host : "smtp.elasticemail.com",
    //     Username: "shaul@elevatione.com",
    //     Password: "620BC001BB58B68BB6ADFD9BF1EACD54A1BD",
    //     To : 'shaul@elevatione.com',
    //     From : "shaul@elevatione.com",
    //     Subject : "New treatment booking from " + first_name + ' ' + last_name,
    //     Body : "First Name: " + first_name + "<br>" + "Last Name: " + last_name + "<br>" + "Email: " + email + "<br>" + "Phone Number: " + phone_number + "<br>" + "Location: " + location
    //   }).then(
    //     res => {
    //       console.log(res);
    //       $('.form-buttom button').addClass('disabled');
    //       $('.form-buttom button').prop('disabled', true);
    //       $('.form-buttom').after('<p class="success">Thanks for the Booking. We will reach you soon.</p>');
    //     }
    //   );
    // } catch(err) {
    //   console.log(err);
    //   $('.form-buttom').after('<p class="success">Something went wrong</p>');
    // }
  });
});

function mobileOnlySlider() {
  $(".slick_photo_gallery").slick({
    dots: true,
    arrows: false,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          autoplaySpeed: 2000,
        },
      },
    ],
  });
}
if (window.innerWidth < 768) {
  mobileOnlySlider();
}

$(".slick_photo_gallery").on("beforeChange", function () {
  //console.log(1);
  var activeIndex = $(".slick-active").index();
  activeIndex = parseInt(activeIndex) - 1;
  $(".photo_gallery .greyscale-bg .image").fadeOut(100);
  $(".photo_gallery .greyscale-bg .image").eq(activeIndex).fadeIn(600);
});

$(window).resize(function (e) {
  if (window.innerWidth < 768) {
    if (!$(".slick_photo_gallery").hasClass("slick-initialized")) {
      mobileOnlySlider();
    }
  } else {
    if ($(".slick_photo_gallery").hasClass("slick-initialized")) {
      $(".slick_photo_gallery").slick("unslick");
    }
  }
});
